module.exports = __webpack_public_path__ + "img/labmemtest_title_tc.78e470c2.png";